























































































import { defineComponent, onUpdated, onMounted, ref, PropType, computed } from '@vue/composition-api';
import NativePlayer from '@/components/NativePlayer.vue';
import MiPlayer from '@/components/MiPlayer.vue';
import MainVideoInfo from '@/components/MainVideoInfo.vue';
import SocialShareInfo from '@/data/SocialShareInfo';
import SharedState from '@/data/SharedState';
import { LayoutType } from '@/data/layout/MainLayoutInfo';
import useCookiebot from '@/composables/useCookiebot';
import Constants from '@/utils/Constants';

export default defineComponent({
  components: {
    MainVideoInfo,
    MiPlayer,
    NativePlayer
  },
  name: 'VideoContainer',
  props: {
    loadError: {
      type: Boolean,
      default: false,
    },
    loadErrorVideoId: {
      type: String,
      default: undefined
    },
    sourceUrl: {
      type: String,
      default: undefined
    },
    posterUrl: {
      type: String,
      default: undefined
    },
    videoId: {
      type: String,
      default: undefined,
    },
    playerId: {
      type: String,
      default: undefined
    },
    title: {
      type: String,
      default: ''
    },
    views: {
      type: Number,
      default: undefined
    },
    dateAddedMs: {
      type: Number,
      default: undefined
    },
    description: {
      type: String,
      default: undefined
    },
    showSocialShareButtons: {
      type: Boolean,
      default: false
    },
    socialShareInfo: {
      type: Object as PropType<SocialShareInfo>,
      required: true
    },
    minHeightVideo: {
      type: Number,
      default: 0
    },
    layoutType: {
      type: Object as PropType<LayoutType>,
      default: undefined
    },
    locale: {
      type: String,
      default: undefined
    }
  },
  emits: {
    'height-change': (value: number) => value > 0,
    'share-video': () => true
  },
  setup(props, context) {

    const containerElem = ref<HTMLElement|null>(null);
    const playerElem = ref<HTMLElement|null>(null);
    const playerKey = ref(0);
    let height = 0;
    let lastClientWidth = 0;


    function onAcceptCookies(): void {
      ++playerKey.value;
    }
    const cookiebotConsentType = 'preferences';
    const cookiebotInfo = useCookiebot(context, cookiebotConsentType, onAcceptCookies);


    const errorMessage = computed(() => {
      let msg = SharedState.getText(context, 'corptube.video.load.error');
      if(props.loadErrorVideoId) {
        msg += ` Id: ${props.loadErrorVideoId}.`
      }
      return msg;
    });

    const contextId = computed(() => {
      return SharedState.getInstance(context).contextInfo.id;
    });

    const getPlayerPlaceholderHeight = () => {
      if(!containerElem.value) return '200px';
      return (containerElem.value.clientWidth / Constants.videoDefaultAspectRatio) + 29 + 'px';
    }

    const assureNonFractionalContainerWidth = () => {

      // For chrome, subpixels and the moving image player.
      // The moving image player and its controls do not align perfectly
      // on certain subpixel fraction. This code tries to work around that.

      if(!containerElem.value) return;

      const cwFractional = containerElem.value.getBoundingClientRect().width;
      const cwWhole = containerElem.value.clientWidth;

      if(cwFractional - Math.floor(cwFractional) < 0.5) return;

      if(Math.abs(lastClientWidth - cwWhole) > 1) {

        lastClientWidth = cwWhole;
        const ratio = cwWhole / cwFractional;
        containerElem.value.style.width = (100.0 * ratio) + '%';
      }
    };

    onUpdated(() => {
      if(!containerElem.value) return;
      if(height != containerElem.value.offsetHeight) {
        height = containerElem.value.offsetHeight;
        context.emit('height-change', height);
      }
      assureNonFractionalContainerWidth();

    });
    onMounted(() => {

      if(!containerElem.value) return;
      height = containerElem.value.offsetHeight;
      assureNonFractionalContainerWidth();

    });

    return {
      containerElem,
      playerElem,
      errorMessage,
      cookiebotInfo,
      playerKey,
      contextId,
      getPlayerPlaceholderHeight,
      cookiebotConsentType
    }
  }
});
